import { JSX } from 'react';
import { RichTextWithCta } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { CreateRichTextWithCtaModel } from './C28RichTextWithCTA.service';
import { C28RichTextWithCTAProps } from './C28RichTextWithCTA.types';

const Default = (props?: C28RichTextWithCTAProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = CreateRichTextWithCtaModel(props);

  return (
    <RichTextWithCta
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C28RichTextWithCTAProps>(Default);
